// removed by extract-text-webpack-plugin
module.exports = {"CreateTeam":"CreateTeam--34UHV","CardContent":"CardContent--3xinA","description":"description--2fMgE"};